/**
 * @constructor
 * @template T
 */
D.SortedMap = function(){
	this._map = {};
	this._list = [];
};

/**
 * @param {string|Number} k
 * @param {T} v
 * @returns {D.SortedMap.<T>}
 */
D.SortedMap.prototype.set = function( k, v ){
	k = String(k);
	if( typeof this._map[k] == 'undefined' ){
		this._list.push(k);
	}
	this._map[k] = v;
	return this;
};

/**
 * @param {String|Number} k
 * @returns {T|null}
 */
D.SortedMap.prototype.get = function(k){
	var re = this._map[k];
	return isset(re) ? re : null;
};

/**
 * @param {String|Number} k
 * @returns {D.SortedMap.<T>}
 */
D.SortedMap.prototype.del = function(k){
	k = String(k);
	if( !this._map[k] ){
		return this;
	}
	delete this._map[k];
	var i = array_search( k, this._list, true );
	this._list.splice( i, 1 );
	return this;
};

/**
 * @returns {D.SortedMap.<T>}
 */
D.SortedMap.prototype.clear = function(){
	this._map = {};
	this._list = [];
	return this;
};

/**
 * @returns {Number}
 */
D.SortedMap.prototype.length = function(){
	return this._list.length;
};

/**
 * @callback D.SortedMapEachCB
 * @param {String,T}
 * @template T
 */

/**
 * @param {D.SortedMapEachCB.<T>|Function} fn
 * @param {object} [$this]
 */
D.SortedMap.prototype.each = function( fn, $this ){
	for( var i = 0; i <  this._list.length; ++ i ){
		var k = this._list[i];
		if( this._map[k] && typeof this._map[k] == 'object' ){
			if( fn.call( ( $this || this._map[k] ), k, this._map[k] ) === false ){
				return false;
			}
		} else {
			if( fn.call( ( $this || this ), k, this._map[k] ) === false ){
				return false;
			}
		}
	}
};

/**
 * @returns {Array.<String>}
 */
D.SortedMap.prototype.keys = function(){
	return [].concat( this._list );
};

/**
 * @returns {Boolean}
 */
D.SortedMap.prototype.empty = function(){
	return !Boolean( this._list.length );
};

/**
 * @returns {Object.<String,T>}
 */
D.SortedMap.prototype.toObject = function(){
	var re = {};
	O2O( re, this._map );
	return re;
};

/**
 * @returns {Array.<T>}
 */
D.SortedMap.prototype.toArray = function(){
	var re = [];
	this.each( function( k, v ){
		re.push(v);
	} );
	return re;
};

/**
 * @param {T} v
 * @returns {Number}
 */
D.SortedMap.prototype.indexOf = function(v){
	var re = array_search( v, this._map );
	if( re === false ){
		return -1;
	}
	return re;
};

/**
 * @returns {T|null}
 */
D.SortedMap.prototype.first = function(){
	if( !this._list.length ){
		return null;
	}
	return this._map[ this._list[0] ];
};

/**
 * @returns {T|null}
 */
D.SortedMap.prototype.shift = function(){
	if( !this._list.length ){
		return null;
	}
	var re =  this.get( this._list[0] );
	this.del( this._list[0] );
	return re;
};

D.SortedMap.prototype.popFirst = function(){
	if( !this._list.length ){
		return;
	}
	this.del( this._list[0] );
};

/**
 * @returns {T|null}
 */
D.SortedMap.prototype.last = function(){
	if( !this._list.length ){
		return null;
	}
	return this._map[ this._list[ this._list.length - 1 ] ];
};

D.SortedMap.prototype.popLast = function(){
	if( !this._list.length ){
		return;
	}
	this.del( this._list[ this._list.length - 1 ] );
};
